import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitEnquiry = (payload) => api.post("/enquiries", payload).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);

export const adminListEnquiries = (token) =>
    api.get("/admin/enquiries", { headers: { "X-Admin-Password": token } }).then((r) => r.data);

export const adminUpdateStatus = (token, id, status) =>
    api
        .patch(`/admin/enquiries/${id}`, { status }, { headers: { "X-Admin-Password": token } })
        .then((r) => r.data);

export const adminDeleteEnquiry = (token, id) =>
    api
        .delete(`/admin/enquiries/${id}`, { headers: { "X-Admin-Password": token } })
        .then((r) => r.data);
